import { Avatar, Box, ButtonBase, Menu, MenuItem, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useRef, useState } from 'react';
import useAuth from 'src/hooks/useAuth';

const Account = () => {
  const ref = useRef(null);
  const { user, logout } = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    try {
      handleClose();
      await logout();
    } catch (err) {
      console.error(err);
      enqueueSnackbar('Unable to logout', {
        variant: 'error',
      });
    }
  };

  return (
    <>
      <Box display="flex" alignItems="center" component={ButtonBase} onClick={handleOpen} ref={ref}>
        <Avatar
          alt="User"
          src={user.avatar}
          sx={{
            height: 32,
            width: 32,
            marginRight: 1,
          }}
        />
        <Typography
          variant="h6"
          color="white"
          sx={{
            display: { xs: 'none', md: 'block' },
          }}
        >
          {user.displayName}
        </Typography>
      </Box>
      <Menu
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        keepMounted
        slotProps={{
          paper: {
            sx: {
              width: 200,
            },
          },
        }}
        anchorEl={ref.current}
        open={isOpen}
      >
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </>
  );
};

export default Account;
